import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { clients } from '../../../reducers/clients/clients.reducer';
import { add, load } from '../../../reducers/projects/projects.actions';
import { projects, loading } from '../../../reducers/projects/projects.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminProjects.css';
import ConnectedProjectForm from './ProjectForm/ProjectForm';
import SelectFormGroup from '../../Forms/SelectFormGroup/SelectFormGroup';

export class AdminProjects extends React.Component {
  constructor() {
    super();
    this.state = {
      year: undefined,
    };
  }

  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areProjectsLoading} />
        <Row style={{ 'margin-bottom': '15px' }}>
          <Col md={2}><Button onClick={this.props.addProject} bsStyle="primary" >Add New Project</Button></Col>
          <Col md={2}>
            <SelectFormGroup
              inputRef={(el) => { this.inputEl = el; }}
              onChange={() => this.setState({ year: this.inputEl.value })}
              options={[
                { name: '2017', id: 17 },
                { name: '2018', id: 18 },
                { name: '2019', id: 19 },
                { name: '2020', id: 20 },
                { name: '2021', id: 21 },
                { name: '2022', id: 22 },
                { name: '2023', id: 23 },
                ]}
            />
          </Col>
        </Row>
        {this.props.projects(this.state.year).map(project => (
          <Row key={project.id} >
            <Col>
              <ConnectedProjectForm project={project} />
            </Col>
          </Row>
        ))}
        <Row><Col><Button onClick={this.props.addProject} bsStyle="primary" >Add New Project</Button></Col></Row>
      </span>
    );
  }
}

AdminProjects.propTypes = {
  load: PropTypes.func.isRequired,
  addProject: PropTypes.func.isRequired,
  areProjectsLoading: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areProjectsLoading: loading(state),
  projects: year => projects(state, year),
  clients: clients(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addProject: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminProjects);



// WEBPACK FOOTER //
// ./src/components/Admin/Projects/AdminProjects.jsx